<template>
  <div>
    <v-list-item
      v-for="(currentAction, i) in currentActions"
      :key="i"
      @click="changeComponent(currentAction[2])"
    >
      <v-list-item-action>
        <v-icon v-text="currentAction[1]"></v-icon>
      </v-list-item-action>

      <v-list-item-title v-text="currentAction[0]"></v-list-item-title>
    </v-list-item>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
  mixins: [apiCalls],
  data() {
    return {};
  }, 
  computed: {
    currentActions() {
      return [
        [
          this.$t("dashboard.menu.current.create_race"), 
          "fa-plus", 
          "RacesCreate"
        ]
      ];
    }
  },
  async mounted() {
    const response = await this.getApi(`/api/v1/promoter/importRace/getUserPromoterSystemFunctions`);
 
    if(response.message){
      this.currentActions.push([this.$t("dashboard.menu.current.import_race"), "fa-file-import", "ImportRaces"]);
    }
   
  },
  methods: {
    changeComponent(component, id = null) {
      this.$emit("isComponent", component, id);
      let params = this.$route.params;
        this.$router.push({
          name: component, params
        });
    },
  },
};
</script>

<style scoped>
.v-list-item__title {
  text-align: left;
}
.v-list-group__items > div > .v-list-item {
  padding-left: 30px;
}
</style>
